import { useState, useEffect } from "react"
import { useQuery } from "react-query"
import Select from "react-select"
import axios from "axios"
import cn from "classnames"
import customStyles from "./styles"
import DropdownIndicatorForSelect from "components/DropdownIndicatorForSelect"
import { betterFetch } from "utils/apis"

const LocationTankPicker = (props: {
  selected?: any
  isDisabled?: boolean
  location?: number
  tank_id?: number
  label?: string
  className?: string
  errorText?: string
  onSelect?: (item: any) => void
  controlStyle?: any
  placeholder?: string
}) => {
  const endpoint = `locations/${props.location}/tanks`
  const { data: tankData, isLoading } = useQuery(
    ["tanks", props.location],
    betterFetch(endpoint, {
      mapper: (data: any) =>
        (data ?? []).map((item: any) => ({
          label: item?.tank_name,
          value: item?.id,
          name: item?.tank_name,
          data: {
            tank_name: item?.tank_name,
            tanks: item?.id,
            tank_id: item?.id,
            id: item?.id,
          },
        })),
    }),
    {
      enabled: !!props.location,
    }
  )
  useEffect(() => {}, [props.location])
  const errorColor = props.errorText ? "red" : "#cbdfea"

  return (
    <div className={cn("flex-c-box", props.className)}>
      {!props.label ? null : (
        <>
          <span style={{ color: "#486f88", fontWeight: "bold" }}>
            {props.label}
          </span>
          <div style={{ marginTop: 4 }} />
        </>
      )}

      <Select
        components={
          props.errorText
            ? { DropdownIndicator: DropdownIndicatorForSelect }
            : {}
        }
        isLoading={isLoading}
        isDisabled={props.isDisabled}
        placeholder={props.placeholder ?? "Choose Tank"}
        options={tankData}
        onChange={props.onSelect}
        styles={customStyles({
          marginRight: 0,
          border: `1px solid ${errorColor}`,
          ...(props.controlStyle ?? {}),
        })}
        defaultValue={tankData?.find(
          (item: any) =>
            item.value ===
            (props.tank_id ||
              props.selected?.[0]?.id ||
              props.selected?.[0]?.tank_id)
        )}
      />
    </div>
  )
}

export default LocationTankPicker
